import { Message } from './message-bus.service';

export class EmployeeUpdatedMessage implements Message {
  constructor(public readonly id: number) {}
}
